import React, { useEffect } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"

import { SideNav } from "../../components";
import { Toaster } from 'react-hot-toast';

export const HomeLayout = () => {
    const navigate = useNavigate()
    const { pathname } = useLocation()

    useEffect(() => {
        if (pathname === "/") { //if user lands on home route by default navigate to campaigns
            navigate("campaigns")
        }
    }, [])

    return (
        <div className="w-dvw h-dvh flex bg-white">
            {/* App name  */}
            <div>

            </div>
            {/* Left side drawer  */}
            <div className="w-1/5">

                <SideNav />
            </div>
            {/* Page content  */}
            <div className="flex-1 h-full overflow-hidden py-8 pt-[52px]">
                <Outlet />
            </div>
            <Toaster />
        </div>
    )
}